import { render } from "./CustomDataTagsModal.vue?vue&type=template&id=4653a8c6&scoped=true"
import script from "./CustomDataTagsModal.vue?vue&type=script&lang=js"
export * from "./CustomDataTagsModal.vue?vue&type=script&lang=js"

import "./CustomDataTagsModal.vue?vue&type=style&index=0&id=4653a8c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4653a8c6"]])

export default __exports__